/**
 * This file was generated by TypeScriptGen v0.0.3
 * Any changes to this file will be lost if regenerated 
 */

enum LimeProductType {
    Dolomite = "Dolomite",
    Calcite = "Calcite",
    Mix = "Mix",
    Gypsum = "Gypsum",
    Magnesium = "Magnesium",
    Other = "Other"
}

export default LimeProductType;
